import React from 'react';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, ClockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const offer = {
  title: 'P.E. READY 360',
  description: '6 Volumes + 5 Bonuses',
  originalPrice: '$90',
  price: '27',
  currency: '$'
};
const includes = ['6 Complete Volumes', '5 Strategic Bonuses', '200+ Training Sessions', '120+ Professional Drills & Games', 'All Age Groups', 'Lifetime Access'];
const ctaHref = 'https://p-e-ready.impultienda.ar/checkout';
const savings = 'SAVE $63';
const trustBadges = [{
  icon: LockIcon,
  label: 'Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Access in 5 min'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Card · GooglePay · ApplePay'
}];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-[#FAFAFA] py-10 sm:py-24 px-4 pt-[30px] pb-[30px]" data-id="element-142">
      <div className="max-w-xl mx-auto" data-id="element-143">
        <div className="text-center mb-5 sm:mb-10" data-id="element-144">
          <span className="inline-block bg-[#FF6B00]/10 text-[#FF6B00] text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest mb-3 sm:mb-4" data-id="element-145">
            Limited-Time Offer
          </span>
          <h2 className="text-2xl sm:text-5xl font-black text-[#0A0A0A] mb-2 sm:mb-3 tracking-tight" data-id="element-146">
            Offer for <span className="text-[#FF6B00]" data-id="element-147">today only.</span>
          </h2>
        </div>

        <div className="relative bg-white border border-[#E5E5EA] rounded-3xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)] overflow-hidden mb-6" data-id="element-148">
          {/* Top accent bar */}
          <div className="h-1.5 w-full bg-[#FF6B00]" data-id="element-149" />

          {/* Ribbon */}
          <div className="flex justify-center -mt-px" data-id="element-150">
            <div className="bg-[#FF6B00] text-white text-[10px] sm:text-xs font-black px-5 py-2 rounded-b-xl uppercase tracking-widest shadow-md" data-id="element-151">
              🏆 Complete Package
            </div>
          </div>

          <div className="px-5 sm:px-10 pt-5 sm:pt-7 pb-6 sm:pb-10 text-center" data-id="element-152">
            {/* Title */}
            <h3 className="text-[#0A0A0A] font-black text-base sm:text-2xl tracking-tight mb-1" data-id="element-153">
              {offer.title}
            </h3>
            <p className="text-[#5A5A66] text-xs sm:text-base font-semibold mb-4 sm:mb-7" data-id="element-154">
              {offer.description}
            </p>

            {/* Includes */}
            <p className="text-[#0A0A0A] text-xs font-black uppercase tracking-widest mb-3 sm:mb-5" data-id="element-155">
              What's included
            </p>
            <div className="grid grid-cols-2 gap-x-4 sm:gap-x-6 gap-y-2 sm:gap-y-3 max-w-md mx-auto text-left mb-5 sm:mb-7 pb-5 sm:pb-7 border-b border-[#E5E5EA]" data-id="element-156">
              {includes.map(item => <div key={item} className="flex items-center gap-2" data-id="element-157">
                  <span className="flex items-center justify-center w-4.5 h-4.5 sm:w-5 sm:h-5 rounded-full bg-[#00C853]/10 flex-shrink-0" data-id="element-158">
                    <CheckIcon className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-[#00C853]" strokeWidth={3} data-id="element-159" />
                  </span>
                  <span className="text-[#0A0A0A] text-xs sm:text-sm font-semibold leading-tight" data-id="element-160">
                    {item}
                  </span>
                </div>)}
            </div>

            {/* Price block — placed right above the CTA */}
            <div className="mb-4 sm:mb-6" data-id="element-161">
              <div className="text-[#5A5A66] text-xs sm:text-sm font-bold mb-1" data-id="element-162">
                Total value:{' '}
                <span className="line-through" data-id="element-163">{offer.originalPrice}</span>
              </div>
              <div className="flex items-start justify-center gap-1" data-id="element-164">
                <span className="font-black text-3xl sm:text-4xl text-[#0A0A0A] mt-1.5 sm:mt-3" data-id="element-165">
                  {offer.currency}
                </span>
                <span className="font-black text-6xl sm:text-8xl text-[#0A0A0A] tracking-tighter leading-none" data-id="element-166">
                  {offer.price}
                </span>
                <span className="self-end mb-1.5 sm:mb-3 ml-1 text-[#5A5A66] text-xs sm:text-sm font-bold" data-id="element-167">
                  USD · one-time
                </span>
              </div>
              <div className="flex items-center justify-center gap-2 sm:gap-3 mt-2.5 sm:mt-4" data-id="element-168">
                <span className="inline-block bg-[#00C853] text-white text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest shadow-sm" data-id="element-169">
                  {savings}
                </span>
                <span className="text-[#5A5A66] text-xs font-bold uppercase tracking-wider" data-id="element-170">
                  Lifetime access
                </span>
              </div>
              <p className="flex items-center justify-center gap-1.5 text-[#5A5A66] text-xs font-semibold mt-3" data-id="element-171">
                💱 You pay in your country's currency
              </p>
            </div>

            {/* Countdown */}
            <div className="flex items-center justify-center gap-3 mb-4 sm:mb-6 bg-[#FAFAFA] py-2.5 sm:py-3 px-4 rounded-xl border border-[#E5E5EA]" data-id="element-172">
              <span className="flex items-center gap-1.5 text-[#0A0A0A] text-xs sm:text-sm font-black uppercase tracking-wider" data-id="element-173">
                <ClockIcon className="w-4 h-4 text-[#FF6B00]" data-id="element-174" />
                Ends in
              </span>
              <CountdownTimer size="sm" blinking={false} data-id="element-175" />
            </div>

            {/* CTA */}
            <a href={ctaHref} className="btn-cta-green block w-full text-center font-black text-base sm:text-xl py-4 sm:py-5 rounded-2xl transition-colors shadow-lg mb-3 sm:mb-4" data-id="element-176">
              {'\uD83D\uDE80 GET P.E. READY 360 NOW \u2014 ONLY $27 USD'}
            </a>

            <p className="flex items-center justify-center gap-1.5 text-[#5A5A66] text-xs font-semibold mb-4 sm:mb-6" data-id="element-177">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-[#00C853]" data-id="element-178" />
              Backed by our 7-day money-back guarantee
            </p>

            {/* Trust badges */}
            <div className="flex flex-wrap items-center justify-center gap-x-4 sm:gap-x-5 gap-y-2 pt-4 sm:pt-6 border-t border-[#E5E5EA]" data-id="element-179">
              {trustBadges.map(({
              icon: Icon,
              label
            }) => <span key={label} className="flex items-center gap-1.5 text-[#5A5A66] text-xs sm:text-sm font-bold" data-id="element-180">
                  <Icon className="w-4 h-4 text-[#FF6B00]" data-id="element-181" />
                  {label}
                </span>)}
            </div>
          </div>
        </div>

        <p className="text-[#5A5A66] text-xs text-center font-semibold" data-id="element-182">
          💱 Price shown in USD — you'll be charged the equivalent in your
          country's local currency.
        </p>
      </div>
    </section>;
}